import { DependencyList, useEffect, useRef } from 'react';

/**
 * Работает, как useEffect, но пропускает первый эффект.
 * Коллбек позволяет получить доступ к предыдущим deps.
 */
export function useDidUpdate<T extends DependencyList>(effect: (prevDeps: T) => void, deps: T): void {
  const prevDeps = useRef<T>(void 0);

  useEffect(() => {
    if (prevDeps.current === deps) return;

    if (!prevDeps.current) {
      prevDeps.current = deps;
      return;
    }

    const result = effect(prevDeps.current);

    prevDeps.current = deps;

    return result;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
